import React from "react";
import { useNavigate } from "react-router-dom";
import logo  from "../assets/logo.png"
export default function Header() {
  const navigate = useNavigate();
   
  const logoutPage = () => {
    localStorage.removeItem("token");
    navigate("/login");
  };
  
  return (
    <div className="navbar navbar-expand-lg navbar-light ">
    <div className="container">
      <a className="navbar-brand" href="!#">
        <img
          src={logo}
          alt="Logo"
          style={{ maxWidth: "200px", maxHeight: "250px" }}
        />
      </a>
      <div className="d-flex justify-content-end align-items-center flex-grow-1">
        <button className="btn btn-warning" onClick={logoutPage}>
          Logout
        </button>
      </div>
    </div>
  </div>
  
  );
}
